<template>
  <div class="evaluate">
    <div>
      <img class="bg" src="https://cms.dafang24.com/aliapp/page/20210708/img/p_01.png">
    </div>
    <div class="btnsBox">
      <img class="bg" src="https://cms.dafang24.com/aliapp/page/20210708/img/p_02.png">
      <a href="javascript:void(0);" class="btn btn04" @click="goHome"></a>
    </div>
    <div>
      <img class="bg" src="https://cms.dafang24.com/aliapp/page/20210708/img/p_03.png">
    </div>
    <!-- 错误信息 -->
    <div class="noLogin"><span></span></div>
  </div>
</template>

<script>
import { orderSource } from "@/utils/env";
import {getConsumerCoupons, DrawCoupon } from "@/utils/api"
export default {
  name: "evaluate",
  data () {
    return {

    }
  },
  methods: {
    goHome () {
      if( orderSource==17 ){
        window.webkit.messageHandlers.goHome.postMessage(2);
      } else if ( orderSource==16 ){
        dfpanda.goHome(2);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.evaluate {
  width: 100%;
  .bg { width: 100%; }
  .btnsBox {
    position: relative;
    .btn {
      display: block;
      position: absolute;
    }
}
  .btnsBox .btn04 {
    width: 95%;
    height: 1.9rem;
    right: 2.5%;
    top: 360px;
  }

  .btnsBox .btn02 {
    width: 95%;
    height: 1.8rem;
    right: 2.5%;
    top: 0;
  }
}
</style>